<template>
  <v-card class="crud-card">
    <v-card-title class="crud-card-title">
      <h2 class="text-h5">{{ content.title }}</h2>
      <v-spacer />
      <v-icon
        class="modal-close"
        color="black"
        @click.stop="$emit('dialogClosed')"
        >{{ icons.mdiClose }}</v-icon
      >
    </v-card-title>
    <v-divider />
    <v-card-text class="crud-card-text" v-html="content.text" />
    <v-card-actions class="crud-card-actions">
      <v-spacer />
      <div class="button-container">
        <GradientButton
          v-if="!hideDeleteButton"
          :title="content.buttonText"
          :small="true"
          :callout="'right'"
          @gradientButtonClicked="deleteItem"
        />
        <DefaultButton
          v-else
          @defaultButtonClicked="$emit('dialogClosed')"
          :title="'Close'"
          :small="true"
        />
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'DeleteDialog',
    props: {
      content: {
        required: true,
        type: Object,
      },
      hideDeleteButton: {
        type: Boolean,
        default: false,
      },
      buttonLoading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        loading: this.buttonLoading,
      };
    },
    watch: {
      buttonLoading: function (newValue) {
        this.loading = newValue;
      },
    },
    methods: {
      deleteItem() {
        this.loading = true;
        this.$emit('delete');
      },
    },
  };
</script>
<style lang="scss" scoped>
  .button-container {
    margin-bottom: 22px;
  }
</style>
